<!-- <div class="row">
    <div class="col-sm-6">
        <div class="card ">
            <div class="card-body ">
                <p class="card-text text-muted">Site : <b>{{siteName}}</b></p>
                <p class="card-text text-muted">System : <b>{{systemName}}</b> </p>
                <p class="card-text text-muted">Employee : <b>{{employee}}</b> </p>
            </div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="card">
            <div class="card-body">
                <p class="card-text text-muted">Product : <b>{{product}}</b></p>
                <p class="card-text text-muted">Date From : <b>{{dateFrom}}</b> </p>
                <p class="card-text text-muted">Date To : <b>{{dateTo}}</b></p>
            </div>
        </div>
    </div>
</div> -->
<app-table-standard-layout *ngIf="columnSettings$ | async; let columnSettings" [sortingArray]="sortingArray" [dataSource$]="values$" [title]="'Report'"
    [columnSettings]="columnSettings">
</app-table-standard-layout>

<!-- <ng-container *ngIf="forceLoading">
    <app-spinner-loading></app-spinner-loading>
</ng-container> -->